import container from '@/container';
import { WindowsServiceContract, CONTRACTS } from '@/core/contracts';
import Uploader from './Uploader.vue';

export function showUploader() {
    const windowsService = container.get<WindowsServiceContract>(CONTRACTS.WindowsService);
    windowsService.showModalComponent(Uploader);
}
